import { Component, ViewChild } from '@angular/core';
import { MsgTemplateEdit } from '../../msg-interface/msg-template-edit';
import { _MSGTYPES, MSG_CONTENT_TYPE } from '../../shared/constant/msgType';
import { URLS } from '../../shared/constant/interface';
import { FormGroup } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { TemplateEditData } from '../../msg-interface/data-model';
import { deepCopy } from '@delon/util';
import { DialogService, TemplateService } from 'icc-common-lib';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tiktok-tpl-edit',
  templateUrl: './tiktok-tpl-edit.component.html',
  styles: [],
})
export class TiktokTplEditComponent implements MsgTemplateEdit {
  SCENE = 'icc-msg-tpl-edit';
  /** 数据源 */
  source: TemplateEditData = {};

  /** 辅助 --消息类型 */
  _MSGTYPES = _MSGTYPES;
  type = _MSGTYPES.MT.TIKTOK.type;
  /** 辅助 -- 图片视频上传接口 */
  uploadUrl = URLS.templateMediaUpload.url;
  /** 辅助 -- 图片视频上传参数 */
  mediaDownParams = 'module=25&attach=7&path=';
  /** 重要 -- 新增的空白模板 */
  standardTemplate = {
    id: 0,
    name: '',
    priority: null,
    msgType: null,
    bizTypeId: null,
    mediaList: [],
    contentType: null,
    content: {
      contentType: 3,
      content: '',
      title: '',
      mediaList: [],
    },
    title: '',
    copyValue: 0,
    operateType: '1',
    isDefault: false,
    editIndex: -1,
    conditions: [],
    patchStrategy: [],
  };
  @ViewChild('form', { static: false }) form: FormGroup;

  constructor(private templateService: TemplateService, private dialogService: DialogService) {}

  // ============================= STRAT 接口实现 ============================= //
  setFormData(data: any): void {
    const { templates = [] } = data;
    this.processTemplate(templates);
    this.source = data;
  }
  getData() {
    const target = deepCopy(this.source.templates);
    target.forEach(it => {
      const _type = Number(it.content.contentType);
      if (_type === MSG_CONTENT_TYPE.IMAGE || _type === MSG_CONTENT_TYPE.VIDEO || _type === MSG_CONTENT_TYPE.AUDIO) {
        it.content.content = null;
      }
      if (_type === MSG_CONTENT_TYPE.TEXT) {
        it.content.mediaList = [];
      }
      it.content = JSON.stringify(it.content);
    });
    return target;
  }
  validate(): boolean {
    let result = true;
    const { ignoreAudit, useTmplMethod, templates } = this.source;

    // ----- 全局校验 -----
    // 抖音只有普通模板
    if (ignoreAudit && templates.length < 1) {
      this.dialogService.notification.error('抖音模板', '发送免审时，需要保证最少含有一个模板');
      return false;
    }

    // ----- 表单校验 -----
    if (templates.length > 0) {
      this.cleanupDirty();

      const inValid = templates.some(item => {
        if (!item.valid || !item.name) {
          this.dialogService.notification.error('抖音模板', '抖音模板名称不能为空，不能重复');
          return true;
        }
        if (!item.content.title) {
          this.dialogService.notification.error('抖音模板', '抖音模板标题不能为空');
          return true;
        }
        if (!item.content.mediaList || item.content.mediaList.length === 0) {
          this.dialogService.notification.error('抖音模板', '抖音模板必须包含视频或图片');
          return true;
        }
      });
      if (inValid) result = false;
    }
    return result;
  }
  // ============================= END 接口实现 ============================= //

  // ============================= START 辅助方法 ============================= //

  /** 添加一些辅助的字段 */
  processTemplate(template: any, isNew: boolean = false) {
    if (template) {
      const _temp = isNew ? [template] : template;
      _temp.forEach((item, index) => {
        if (typeof item.content === 'string') item.content = JSON.parse(item.content);
        item.valid = true; // 是否是有效的模板名称
        item.vIndex = item.content ? item.content.length : 0; // content光标的位置
        item.copyValue = 0; // 复用了哪一个模板
        item.htmlId = isNew ? `msgType${this.type}${this.source.templates.length}` : `msgType${this.type}${index}`; // 标识符
      });
    }
  }

  /** 模板增加后的回调 */
  updateHandle() {
    const target = this.templateService.getLastTpl(this.type);
    this.processTemplate(target, true);
  }

  /** 手动驱动校验 */
  cleanupDirty() {
    setTimeout(() => {
      // tslint:disable-next-line: forin
      for (let a in this.form.controls) {
        this.form.controls[a].markAsDirty();
        this.form.controls[a].updateValueAndValidity();
      }
    }, 100);
  }

  // ============================= END 辅助方法 ============================= //
}
